<div class="alt-row-align-center alt-row-between gap-2">
  <div class="alt-row-align-center alt-row-between">
    <app-general-time-circle
      [color]="colors[0]"
      [title]="'CHALLENGES.byActivity'"
      [timeNumber]="timeNumber(averageActivity)"
      [timeText]="timeText(averageActivity)"
    ></app-general-time-circle>
    <app-general-time-circle
      [color]="colors[1]"
      [title]="'CHALLENGES.byChallenge'"
      [timeNumber]="timeNumber(averageChallenge)"
      [timeText]="timeText(averageChallenge)"
    ></app-general-time-circle>
    <app-general-time-circle
      [color]="colors[3]"
      [title]="'CHALLENGES.byCompleted'"
      [timeNumber]="timeNumber(averageTotal)"
      [timeText]="timeText(averageTotal)"
    ></app-general-time-circle>
  </div>
  <div class="alt-row-align-center gap-2">
    <div
      *ngFor="let challenge of challengesTime; let i = index"
      class="challenge-time-card alt-column-align-center"
    >
      <div class="alt-column-align-center">
        <div class="time-circle">
          <circle-progress
            [options]="optionsGraph"
            [percent]="100"
            [radius]="32"
            [innerStrokeWidth]="8"
            [innerStrokeColor]="colors[i]"
          ></circle-progress>
          <div class="time-text alt-column-align-center">
            <p class="alt-inter-semibold alt-size-14 alt-color-grayscale2">
              {{ timeNumber(challenge.time_total) }}
            </p>
            <p
              class="time-date alt-inter-regular alt-size-12 alt-color-grayscale2"
            >
              {{ timeText(challenge.time_total) | translate }}
            </p>
          </div>
        </div>
        <p class="alt-inter-semibold alt-size-16">
          {{ "CHALLENGES.challengeText" | translate }}:
          {{ challenge.number_challenge }}
        </p>
      </div>
      <div class="alt-flex-column-start">
        <div *ngFor="let activity of challenge.activities" class="alt-flex-row">
          <p class="alt-inter-semibold alt-size-14">
            {{ "CHALLENGES.activity" | translate }}:
            {{ activity.number_activity }}
          </p>
          <p class="time-separator alt-inter-semibold alt-size-14">-</p>
          <p class="alt-inter-semibold alt-size-14">
            {{ timeNumber(activity.time_total) }}
            {{ timeUnit(activity.time_total) | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
